import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { Spin, Badge, Tooltip } from 'antd';

import * as ToolRequest from '../../tools/ToolRequest';

export default function StationStatus(props) {
  const [loaded, setLoaded] = useState(true);
  const [isConnected, setIsConnected] = useState(false);
  const [currentConnectionBeginAt, setCurrentConnectionBeginAt] = useState(null);

  useEffect(() => {
    reload();
  }, []);

  const reload = () => {
    if (!loaded) {
      return;
    }
    setLoaded(false);

    ToolRequest.request('GET', '/v1/station-status', {
      stationId: props.id,
    })
    .then(({isSocketConnecting, socketCurrentConnectionBeginAt}) => {
      setIsConnected(isSocketConnecting);
      setCurrentConnectionBeginAt(socketCurrentConnectionBeginAt);
      setLoaded(true);
    });
  };

  return loaded ? (
    <div onClick={() => reload()}>
      <Tooltip title={currentConnectionBeginAt ? moment(currentConnectionBeginAt).fromNow() : 'Currently offline'}>
        <Badge status={isConnected ? 'success' : 'error'} />

        {isConnected ? 'Online' : 'Offline'}
      </Tooltip>
    </div>
  ) : (
    <Spin size="small" />
  );
};